import { types } from 'mobx-state-tree';
import { ExtendedModel, model } from 'mst-collection';

import { Photo } from './PhotoModel';

export class IdentifiedPhoto extends ExtendedModel(Photo, {
  id: types.string,
}) {}

export const IdentifiedPhotoModel = model(IdentifiedPhoto);
